import React from "react";
import "./NoConnection.css";

const NoConnection = () => {
  return (
    <div className="no-connection">
      <div className="no-connection-content">
        <h1>Pas de connexion internet</h1>
        <p>Veuillez vérifier votre connexion internet et réessayer.</p>
      </div>
    </div>
  );
};

export default NoConnection;
